import { Component, OnInit, Input } from '@angular/core';
import { CustomerService } from '../../../../core/services/customer.service';
import { AddressType, ICustomer, ICustomerAddress, ICustomerArchiveAddress,  IMasterData, IState,
   ICountry, 
   ICustomerAddressLabel} from '../../../../core/models';
import { tap, map } from 'rxjs/operators';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { MasterDataService } from '../../../../core/services/master-data.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Info } from '../../../../core/common';
import { CheckoutService } from '../../../../core/services/checkout.service';
import { UserService } from '../../../../core/services/user.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';

@Component({
  selector: 'app-manage-address',
  templateUrl: './manage-address.component.html',
  styleUrls: ['./manage-address.component.scss']
})
export class ManageAddressComponent implements OnInit {
  lblText: ICustomerAddressLabel;
  protected manageAddressGridView: GridDataResult;
    isDisabled: boolean;
  constructor(private customerService: CustomerService,
    private userService: UserService,
    private appNotifyService: AppNotifyService,
    private checkoutService: CheckoutService,
    private masterDataService: MasterDataService, private languageTranslationService: LanguageTranslationService) { }
  @Input() showAddAddressBtn: boolean = true;
   public saveInProcess: boolean;
   public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  currentZipCode: string;
  public showValidationInfo: boolean;
  public inputValidationMessage: string = "Only following special characters are allowed: Comma(,), Dash(-) and Dot(.)";
  protected manageAddress = {
    addAddressLbl: 'Add New Shipping Address',
    customerNumberLbl: 'Customer Number',
    nameLbl: 'Mailing Name',
    addressLine1Lbl: 'Address Line 1',
    addressLine2Lbl: 'Address Line 2',
    duplicateAddressText1: 'We found similar addresses at the',
    duplicateAddressText2: 'you entered, you can either select address from the table below or click on',
    duplicateAddressText3: 'to create new address and customer',
    cityLbl: 'City',
    stateLbl: 'State',
    zipcodeLbl: 'Zip Code',
    countryLbl: 'Country',
    countyLbl: 'County',
    phoneNumberLbl: 'Phone Number',
    phoneValidationLbl: 'Phone number length should be minimum 10',
    archiveLbl: "Archive",
    closeLbl: "Close",
    saveLbl: "Save",
    shippingAddressLbl: "Shipping Address",
    selectAddressLbl: 'Select Address',
    selectLbl: 'Select',
    addNewAddressLbl: 'Add New Address',
    isDefaultLbl: "isDefault",
    addressList: [],
    manageAddressGrid: {
      addressList: [],
      gridLoading: false
    },

  };
protected addShippingDialog = {
    opened: false,
    loading: false,
    defaultState: { name: 'Select State', value: null } as IMasterData,
    defaultCountry: { name: 'Select Country', value: null } as IMasterData,
    states: [] as IState[],
    countries: [] as ICountry[],
    isSubmitted: false,
    isInvalidCustomerName:false,
    isInvalidAddressLine1:false,
    isInvalidAddressLine2:false,
    isInvalidCity:false,
    isInvalidCountry:false,
    isInvalidState:false,
    isInvalidZipCode:false,
    isInvalidCounty:false,
    isInvalidPhoneNumber:false,
    isInvalidPhoneNumberMessage:false,
    isValidForm:this.validateAddShippingForm()
  };
  protected addShippingForm: FormGroup;
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.addShippingForm = this.addShippingFormGroup();
    this.manageAddress.manageAddressGrid.gridLoading = true;
    this.customerService.getAllAddressList().pipe(tap((customers: ICustomer[]) => {
      this.customerService.addressList = customers as ICustomer[];
    })).subscribe((customers: ICustomer[]) => {     
      this.loadManageAddress();
      this.manageAddress.manageAddressGrid.gridLoading = false;
    });

    this.masterDataService.GetCountries().pipe(tap((countries: ICountry[]) => {
      this.masterDataService.countries = countries as ICountry[];
    })).subscribe((countries: ICountry[]) => {

      this.addShippingDialog.countries = countries as ICountry[];
    })
  }
  //#region Language translate
  loadLanguageTranslationData() {
    //need to add remaining fields
    const controlNameList = [
      { controlName: "addAddressLbl" },
      { controlName: "customerNumberLbl" },
      { controlName: "addressLine1Lbl" },
      { controlName: "addressLine2Lbl" },
      { controlName: "cityLbl" },
      { controlName: "manageAddressLbl" },
      { controlName: "nameLbl" },
      { controlName: "shipToLbl" },
      { controlName: "stateLbl" },
      { controlName: "zipcodeLbl" },
      { controlName: "shippingAddressLbl" },
      { controlName: "isDefaultLbl" },
      { controlName: "phoneNumberLbl" },
      { controlName: "phoneValidationLbl" },
      { controlName: "archiveLbl" },
      { controlName: "closeLbl" },
      { controlName: "saveLbl" },
      { controlName: "countryLbl" },
      { controlName: "countyLbl" },
      //add more field here
    ];
    const componentName = "manageaddress";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    //same component is being used on checkout screen
    if (response.length > 0) {
      this.lblText = response[response.length - 1];
    } 
    console.log(response);
  }

  //#endregion
  protected gridSettings = {
    //pageSizes: [10, 20, 30, 40, 50],   
    gridLoading: false
  };

  public state: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: '',
      dir: 'asc'
    }],
    //sort: [{
    //  field: 'customerNumber',
    //  dir: 'desc'
    //}],
    filter: {
      logic: 'and',
      filters: []
    },
  };
 


  private loadManageAddress(): void {
    const shippingaddressList = this.customerService.getAddressList
    this.manageAddressGridView = process(shippingaddressList, this.state); 
  }


  protected manageAddressGridSortChange(sort: SortDescriptor[]): void { 
    this.state.sort = sort;
    this.loadManageAddress();
  }
  protected manageAddressGridPageChange({ skip, take }: PageChangeEvent): void {
    this.state.skip = skip;
    this.state.take = take;
    this.loadManageAddress();
  }

  public manageAddressDataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.loadManageAddress();   
  }

  //#region ManageAddress Grid Events & Operations
  protected archiveUnarchiveAddress(dataItem: ICustomerArchiveAddress): void {
    (dataItem as ICustomerArchiveAddress).isActive = !(dataItem as ICustomerArchiveAddress).isActive;
    //this.customerService.getAddressList
    this.manageAddress.manageAddressGrid.gridLoading = false;
    dataItem.updateInProgress=true;
    this.customerService.archiveAddress(dataItem)
      .subscribe((archiveAddressStatus) => {        
        this.manageAddress.manageAddressGrid.gridLoading = false;
        dataItem.updateInProgress=false;
        this.loadManageAddress();
      })

  }
  protected isDefaultAddress(dataItem): void {
    var user = this.userService.readUserObject;
    this.manageAddress.manageAddressGrid.gridLoading = false;
    dataItem.userName = user.userName;
    dataItem.isDefaultUpdateInProgress = true;
    this.customerService.isDefaultAddress(dataItem)
      .subscribe((archiveAddressStatus) => {
        this.customerService.updateIsDefaultAddressLocal(dataItem);
        if (this.checkoutService.checkOutProcessModel && this.checkoutService.checkOutProcessModel.currentShipping) {
          this.checkoutService.checkOutProcessModel.currentShipping.isSelected = false;
          this.checkoutService.checkOutProcessModel.currentShipping = dataItem;
          this.checkoutService.checkOutProcessModel.shipToCustomerNumber = dataItem.customerNumber;
        }
        this.manageAddress.manageAddressGrid.gridLoading = false;
        dataItem.isDefaultUpdateInProgress = false;
        if (dataItem.isDefault == false) {
          user.defaultShippingAddressNumber = null;
        }
        else {
          user.defaultShippingAddressNumber = dataItem.customerNumber;
        }
        this.userService.saveUserObject(user);
        this.loadManageAddress();
      })
  }
  protected get f() {
    return this.addShippingForm.controls;
  }
  protected validateAddShippingForm():boolean{
   
    let isValid=true;
    if(!this.addShippingDialog){
      return;
    }
    if(this.addShippingDialog.isSubmitted){
      

      if(this.f.customerName.value){
        this.addShippingDialog.isInvalidCustomerName=false;
      }else{
        this.addShippingDialog.isInvalidCustomerName=true;
        isValid=false;
      }

      if(this.f.addressLine1.value){
        this.addShippingDialog.isInvalidAddressLine1=false;
      }else{
        this.addShippingDialog.isInvalidAddressLine1=true;
        isValid=false;
      }

      if(this.f.city.value){
        this.addShippingDialog.isInvalidCity=false;
      }else{
        this.addShippingDialog.isInvalidCity=true;
        isValid=false;
      }
      
      if(this.f.country.value){
        this.addShippingDialog.isInvalidCountry=false;
      }else{
        this.addShippingDialog.isInvalidCountry=true;
        isValid=false;
      }

      if(this.f.state.value){
        this.addShippingDialog.isInvalidState=false;
      }else{
        this.addShippingDialog.isInvalidState=true;
        isValid=false;
      }

      if(this.f.zipCode.value){
        this.addShippingDialog.isInvalidZipCode=false;
      }else{
        this.addShippingDialog.isInvalidZipCode=true;
        isValid=false;
      }

      if(this.f.phoneNumber.value){
       
        this.addShippingDialog.isInvalidPhoneNumber=false;
        if((this.f.phoneNumber.value as string).toString().length!==10){
          this.addShippingDialog.isInvalidPhoneNumber=true;
          this.addShippingDialog.isInvalidPhoneNumberMessage=true;
          isValid=false;
        }else{
          this.addShippingDialog.isInvalidPhoneNumber=false;
          this.addShippingDialog.isInvalidPhoneNumberMessage=false;
        }

      }else{
        this.addShippingDialog.isInvalidPhoneNumber=true;
        isValid=false;
      }
    }
    return isValid;
  }
  // adding zipcode duplicate check
  protected selectShippingAddress(dataItem: ICustomer): void {
    //find existing selected address and unselect it

    if (this.checkoutService.checkOutProcessModel.currentShipping) {
      this.checkoutService.checkOutProcessModel.currentShipping.isSelected = false;
    }

    dataItem.isSelected = true;
    this.checkoutService.checkOutProcessModel.currentShipping = dataItem;
    this.checkoutService.checkOutProcessModel.shipToCustomerNumber = dataItem.customerNumber;
    const tempCustomer = this.customerService.getAddressList.find(r => r.customerNumber === dataItem.customerNumber);
    tempCustomer.isSelected = true;
    this.customerService.getAddressList.filter(r => r.customerNumber !== dataItem.customerNumber).forEach((item, index) => {
      item.isSelected = false;
    });
  
    //if (this.addShippingDialog.opened) {
    //  //this.addShippingDialogClose();
    //  this.duplicateAddressList = [];
    //}
    //if (this.isMobileOrTab) {
    //  this.hideShippingAddrGrid = true;
    //  this.hideShippingAddr.emit(true);
    // }

    //fire Ship To Change event
    //console.log(dataItem);
    this.checkoutService.shipToChangeSubject.next(dataItem);//good one

  }
  public duplicateAddressList = [];
  public duplicateAddressCheck(addShippingForm: ICustomer) {
    if (!addShippingForm.state) addShippingForm.state = "";
    if (!addShippingForm.zipCode) addShippingForm.zipCode = "";
    this.duplicateAddressList = this.customerService.getAddressList
      .filter(r => r.zipCode == addShippingForm.zipCode);
  }
  doDuplicateAddressCheck: boolean = true;
  statusCheck() {
    if (this.currentZipCode != this.f.zipCode.value) {
      this.doDuplicateAddressCheck = true;
    }
  }

  protected addNewShippingHandler(event, addShippingForm: ICustomer) {
    this.currentZipCode = addShippingForm.zipCode;
    this.infoMessage=new Info();
    this.addShippingDialog.isSubmitted = true;
    this.validateAddShippingForm();

    if (this.validateAddShippingForm()) {  //checking whether add customer popup form is valid or not
      this.isDisabled = true;

      if (this.doDuplicateAddressCheck) {
        this.duplicateAddressCheck(addShippingForm);
        this.doDuplicateAddressCheck = false;
        if (this.duplicateAddressList.length > 0) {

          this.isDisabled = false;
          return;
        }
          
      }
      
      this.inProgressMessage = true;
      this.saveInProcess = true;
      this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
      addShippingForm.phoneNumber.toString();
      const body={
        addressLine1: addShippingForm.addressLine1,
        addressLine2: addShippingForm.addressLine2,
        city:  addShippingForm.city,
        country:  addShippingForm.country,
        county:  addShippingForm.county,
        customerName:  addShippingForm.customerName,
        parentCustomerNumber: addShippingForm.parentCustomerNumber,
        parentCustomerName: this.userService.readUserObject.customerName,
        phoneNumber:  addShippingForm.phoneNumber.toString(),
        state:  addShippingForm.state,
        zipCode: addShippingForm.zipCode

      }

      this.customerService.addShippingAddress(body as ICustomer)
        .subscribe((customer: ICustomer) => {
          this.infoMessage.genericInProgress = "";
          this.saveInProcess = false;
          if (customer) {
            this.customerService.addAddressToList(customer);
            //this.state.sort = [{
            //  field: 'customerNumber',
            //  dir: 'desc'
            //}];
           // this.loadManageAddress();
            //this.setDefaultAddress();
            this.selectShippingAddress(customer);
            let shippingaddressList = this.customerService.getAddressList.filter((address: ICustomer) =>
              (address.billingType === AddressType.Shipping || address.billingType === AddressType.Both) && address.isActive);

            //make the newly added shipping address in first row
            const newAddr = shippingaddressList.find(x => x.customerNumber == customer.customerNumber);
            const newAddrIndex = shippingaddressList.findIndex(x => x.customerNumber == customer.customerNumber);
            if (newAddr) {
              shippingaddressList.splice(newAddrIndex, 1);
              shippingaddressList.splice(0, 0, newAddr);
              this.manageAddressGridView = process(shippingaddressList, this.state);
            }
            //show status
            this.infoMessage.genericSuccess = "New shipping address " + customer.customerNumber + " saved.";
          } else {
            ///show status
            this.infoMessage.genericError = this.infoMessage.errorMessage;
          }

          this.isDisabled = false;
          this.resetAddShippingForm();
        })
    }
  }
  protected addShippingFormGroup() {
    return new FormGroup({
      customerName: new FormControl(""),
      addressLine1: new FormControl(""),
      addressLine2: new FormControl(""),
      city: new FormControl(""),
      state: new FormControl(""),
      zipCode: new FormControl(""),
      country: new FormControl(""),
      county: new FormControl(""),
      phoneNumber: new FormControl("")
    });
  }
  public addShippingDialogClose() {
    this.addShippingDialog.opened = false;
    this.addShippingDialog.isSubmitted = false;
    this.addShippingForm = this.addShippingFormGroup();
    // this.loadAddress();
     this.infoMessage = new Info();
     this.saveInProcess = false;
  }
  public addShippingDialogCountySelectionChange(event) {
    //const selectedCounty = this.f.country.value;
    console.log(event);
    console.log(this.f.country.value);
    if (event) {
      this.addShippingDialog.states = event.states;
    }
   
    this.validateAddShippingForm();
  }
  addShippingDialogStateSelectionChange(value) {
    if (value.stateCode) {
    
    } 
    this.validateAddShippingForm();
  }
  public addShippingDialogOpen() {
    this.addShippingDialog.opened = true;
    this.addShippingDialog.isSubmitted = false;
  }
  protected resetAddShippingForm(){
    this.addShippingDialog.isInvalidCustomerName=false,
    this.addShippingDialog.isInvalidAddressLine1=false,
    this.addShippingDialog.isInvalidAddressLine2=false,
    this.addShippingDialog.isInvalidCity=false,
    this.addShippingDialog.isInvalidCountry=false,
    this.addShippingDialog.isInvalidState=false,
    this.addShippingDialog.isInvalidZipCode=false,
    this.addShippingDialog.isInvalidCounty=false,
    this.addShippingDialog.isInvalidPhoneNumber=false,
    this.addShippingDialog.isInvalidPhoneNumberMessage=false;
    this.addShippingDialog.isValidForm=this.validateAddShippingForm();
    this.addShippingDialog.loading=false;
    this.addShippingDialog.isSubmitted=false;
    this.addShippingForm.reset()
    this.duplicateAddressList = [];
    this.doDuplicateAddressCheck = true;
  }
  public showInfo(event: boolean) {
    if (!event)
      this.showValidationInfo = true;
    else
      this.showValidationInfo = false;
      //console.log("Only following special character allowed: , - .");
  }
  //#endregion
}
